import $ from 'jquery';
import castingTmpl from './hbs/casting.hbs';
import { callApi } from './util';
const $castingTmpl = $.templates(castingTmpl);


function castingDesc(ctx) {
  const $ctx = ctx;
  const $castingList = $ctx.find('.castingList ul');
  openDesc($castingList, 5, $ctx);
}
function openDesc(castingList, std, $ctx) {

  castingList.each(function () {
    const $list = $(this).children('li');
    const $charName = $list.find('.f_link');
    const len = $list.length;
    let $this = $list.filter('.on');
    $list.on('click', function () {
      $this = $(this);
      const charId = $this.find('.wrap_thumb').data('id');
      if (!charId) {
        return;
      }

      $list.parent().find('.info_appear').remove();
      const idx = $this.index() + 1;
      const u = Math.ceil(idx / std);
      // const dataUrl = '/qsearch?w=iron&m=tv_character&q=' + charId + '&key=' + charId + '&viewtype=json';
      const params = {
        cnucc: '',
        w: 'iron',
        m: 'tv_character',
        q: charId,
        key: charId,
        viewtype: 'json'
      };
      const dataUrl = SF.getQsUrl(params, 1);
      callApi(dataUrl).done((response) => {
        try {
          const castingData = response.RESULT.IRON_TV_CHARACTER;
          const castingCharacter = castingData.character;
          const desc = castingCharacter.description;

          if (charId && castingData !== null && desc !== '') {
            castingFunc(response);
          } else {
            return;
          }

          const $btnClose = $this.siblings().find('.ico_close_l');
          $btnClose.on('click', function () {
            $list.parent().find('.info_appear').remove();
            $list.removeClass('on');
          });
        } catch (e) {
          console.log(e);
        }

        function castingFunc(response) {
          const castingData = response.RESULT.IRON_TV_CHARACTER;
          const castingCharacter = castingData.character;

          $list.removeClass('on');
          $this.addClass('on');

          const htmlOutput = $castingTmpl.render(castingData, {
            sameListLength: function (length) {
              return Math.ceil(length);
            },
            replaceProf: function () {
              const birthday = castingData.homo.solarCalendar;
              const year = birthday.substr(0, 4);
              const month = birthday.substr(4, 2);
              const day = birthday.substr(6, 2);
              return { year, month, birthday: `${year}.${month}.${day}` };
            },
            encodeUri: function (txt) {
              return encodeURIComponent(txt);
            },
            sourceUrl: function () {
              const homepageUrl = castingCharacter.homepage.length > 0 ? castingCharacter.homepage[0].url : undefined;
              return castingCharacter.sourcePcUrl || homepageUrl || castingCharacter.channel.homepageUrl || '';
            },
            docId: function () {
              return C.TVP.data.docId;
            }
          });


          (u * std) >= len ? $list.last().after(htmlOutput) : $list.eq(u * std).before(htmlOutput);
          paging();
        }

        function paging() {
          const nav = $ctx.find('.info_appear .paging_nav');
          const sameList = $ctx.find('.same_character .info_actor');
          new SF.pager({
            navigation: nav,
            list: sameList,
            viewCount: 2,
            isInfinite: false
          });
        }

      });
    });
    $charName.on('click', function (e) {
      e.stopPropagation();
    });
    $this ? $this.click() : $this;
  });
}

export default castingDesc;


/** WEBPACK FOOTER **
 ** ./src/TVP/casting.js
 **/